import AppBarMui from '@mui/material/AppBar'
import styled, { keyframes } from 'styled-components'
import { ReactComponent as BaseLogoGlobo } from 'assets/icons/logo-icon.svg'
import { APP_BAR_HEIGHT, COLOR_APP_BAR_DEFAULT } from 'commons/constants/layout'

const rightToLeft = keyframes`
  0% {  transform: translateX(30px); opacity: 0; }
  100% { transform: translateX(0); opacity: 1; }
`

const AppBarContainer = styled(AppBarMui)<{ $menuOpen: boolean; $date: number }>`
  padding-left: 18px;
  flex-direction: row;
  justify-content: space-between;

  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;

  height: ${APP_BAR_HEIGHT}px;
  z-index: ${({ $menuOpen }) => ($menuOpen ? 'unset' : 1201)} !important;

  background: ${COLOR_APP_BAR_DEFAULT} !important;
  border-bottom: 1px solid;
  border-image-slice: 1;
  border-image-source: ${COLOR_APP_BAR_DEFAULT};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-left: 8px;
  }
`

const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
`

const ContainerLogoGlobo = styled.div`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-right: 12px;
  }
`

const Separator = styled.div`
  height: 20px;
  width: 1px;
  background-color: var(--color-white-a32);
  margin: 0 20px;
`

const LogoGlobo = styled(BaseLogoGlobo)<{ $isSmall: boolean }>`
  display: ${({ $isSmall }) => ($isSmall ? 'none' : 'flex')};
  animation: ${rightToLeft} 1.5s ease;
`

const PalcoName = styled.span<{ $isSmall: boolean }>`
  display: ${({ $isSmall }) => ($isSmall ? 'none' : 'flex')};

  font-size: var(--font-size-125);
  font-weight: var(--font-weight-medium);
  font-family: var(--font-family-sans);
  line-height: 24px;
  color: var(--content-inverse);

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin-left: 12px;
  }
`

const UserContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid var(--color-white-a32);
  border-radius: 4px;
  margin: 6px;
  padding: 4px 8px;
  cursor: pointer;
  margin-right: 26px;
`

export { AppBarContainer, Toolbar, LogoGlobo, ContainerLogoGlobo, PalcoName, UserContainer, Separator }
